export const types = {
  INPUT: "NAME_INPUT",
};

const input = (value) => ({
  type: types.INPUT,
  value,
});

export const actions = {
  input,
};
